import AuthModel from '../../model/AuthModel';

export default class AuthenticationUtil {

  static _auth: AuthModel;
  static _accept: any;
  static _reject: any;

  // constructor() {

  // }

  static require(accept: any, reject: any, text = 'Informe sua senha para prosseguir.') {
    AuthenticationUtil._accept = accept;
    AuthenticationUtil._reject = reject;
    AuthenticationUtil._show();
    AuthenticationUtil._auth.setText(text);
  }


  static accept() {
    AuthenticationUtil._accept();
    AuthenticationUtil._hide();
  }

  static reject() {
    if (AuthenticationUtil._reject) {
      AuthenticationUtil._reject();
    }
    AuthenticationUtil._hide();
  }

  static _show() {
    AuthenticationUtil._auth.setPassword('');
    AuthenticationUtil._auth.setVisible(true);
  }

  static _hide() {
    AuthenticationUtil._auth.setVisible(false);
  }

  static init(auth: any) {
    AuthenticationUtil._auth = auth;
  }
}
